// RedirectingPage.js
import React from "react";
import API_URL from "../config/config";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useState } from "react";
import { Box, Spinner, Text } from "grommet";
import { jwtDecode } from "jwt-decode";
const RedirectingPage = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  //   login(accessToken);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // After the first request is done, run the second request to /user/redirect
        const redirectResponse = await axios.get(`${API_URL}/user/redirect`);

        // Extract the JWT token and the URL from the response
        const { jwtToken, url } = redirectResponse.data;
        console.log("Redirect response:", redirectResponse.data);
        // Perform the login operation with the JWT token
        login(jwtToken);
        const decodedToken = jwtDecode(jwtToken);
        const userId = decodedToken.user_id;
        const userRole = decodedToken.role;
        console.log(decodedToken);

        navigate(`${url}`);

        // Log and navigate to the redirect URL

        setLoading(false);
      } catch (error) {
        console.error("Error redirecting:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, []);

  if (loading) {
    return (
      <Box fill align="center" justify="center">
        <Spinner size="large" />
        <Text>Please wait...</Text>
      </Box>
    );
  }
};

export default RedirectingPage;
